import { connect } from 'react-redux';
import PersonContactDialog from './PersonContactDialog';
import {
    addPersonContactBegin,
    updatePersonContactBegin,
    getContactTypesBegin,
    getAddPersonConfiguredFormBegin,
} from '../../../../store/actions/person.actions';
import {
    getAddPersonForm,
    getAddPersonFormLoadingStatus,
    getContactTypes,
} from '../../../../store/selectors/person.selectors';

const mapStateToProps = (state: any) => {
    const contactTypes = getContactTypes(state);
    const addPersonForm = getAddPersonForm(state);
    const isLoading = getAddPersonFormLoadingStatus(state);
    return { contactTypes, addPersonForm, isLoading };
};

const mapDispatchToProps = {
    getContactTypes: getContactTypesBegin,
    addPersonContact: addPersonContactBegin,
    updatePersonContact: updatePersonContactBegin,
    getAddContactForm: getAddPersonConfiguredFormBegin,
};

export default connect(mapStateToProps, mapDispatchToProps)(PersonContactDialog);
